import type { FunctionComponent } from 'react';

export const RequestNewIcon: FunctionComponent = () => (
    <svg fill="none" height="16" viewBox="0 0 17 16" width="17" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.66683 14.1667H4.66683C3.93045 14.1667 3.3335 13.5697 3.3335 12.8333V3.16668C3.3335 2.4303 3.93045 1.83334 4.66683 1.83334H11.6668C12.4032 1.83334 13.0002 2.4303 13.0002 3.16668V8.16668M11.6668 10.1667V12.1667M11.6668 12.1667V14.1667M11.6668 12.1667H9.66683M11.6668 12.1667H13.6668"
            stroke="#6E6E6C"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);
